import React from 'react';

const userAuthContext = React.createContext({ isUserAuthenticated: false });

export { userAuthContext };
